/* Zutaten-Steckbriefe.
 *
 * Jede Zutat auf der Seite ist ein <button data-zutat="<key>">. Beim ersten
 * Klick werden die Daten einmal geladen (assets/steckbriefe.json), danach
 * liegen sie im Speicher.
 *
 * Am Schreibtisch oeffnet sich ein Blatt NEBEN der Zutat, schmal oeffnet es
 * sich von unten. Escape und ein Klick daneben schliessen, der Fokus kehrt
 * zum Knopf zurueck, aria-expanded sagt jederzeit, was offen ist.
 *
 * Keine Bibliothek: die Position rechnen wir selbst aus dem Rechteck des
 * Knopfes. Das sind zwanzig Zeilen und spart 12 kB Fremdcode.
 */
(function () {
  'use strict';

  var knoepfe = document.querySelectorAll('[data-zutat]');
  if (!knoepfe.length) return;

  var URL_DATEN = document.documentElement.getAttribute('data-steckbriefe')
    || 'assets/steckbriefe.json';
  var PFAD = document.documentElement.getAttribute('data-pfad') || '';

  var daten = null;
  var laedt = null;
  var offen = null;        /* { knopf, panel, schatten } */
  var schmal = window.matchMedia('(max-width: 47.9375rem)');

  function holen() {
    if (daten) return Promise.resolve(daten);
    if (!laedt) {
      laedt = fetch(URL_DATEN)
        .then(function (a) { return a.ok ? a.json() : null; })
        .then(function (j) { daten = j; return j; })
        .catch(function () { return null; });
    }
    return laedt;
  }

  function e(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function bau(z, bildHtml) {
    var sorten = z.steckt_in.map(function (s) {
      return '<li><a href="' + PFAD + 'products/' + e(s.slug) + '" data-flavor="'
        + e(s.slug) + '">'
        + '<span class="steckbrief__sorte">' + e(s.name) + '</span>'
        + (s.rolle ? '<span class="steckbrief__rolle">' + e(s.rolle) + '</span>' : '')
        + (s.verarbeitung
            ? '<span class="steckbrief__etikett">Im Zutatenverzeichnis: '
              + e(s.verarbeitung) + '</span>'
            : '')
        + '</a></li>';
    }).join('');

    return ''
      + '<div class="steckbrief__kopf">'
      +   '<span class="steckbrief__bild">' + (bildHtml || '') + '</span>'
      +   '<h3 class="steckbrief__name" id="steckbrief-titel">' + e(z.name) + '</h3>'
      +   '<button class="steckbrief__zu" type="button">'
      +     '<span class="visually-hidden">Steckbrief schließen</span>'
      +     '<span aria-hidden="true">×</span></button>'
      + '</div>'
      + '<h4>Warum sie drin ist</h4><p>' + e(z.was) + '</p>'
      + (z.natur ? '<h4>Was in ihr steckt</h4><p>' + e(z.natur) + '</p>' : '')
      + '<h4>Geschmack und Rolle</h4><p>' + e(z.geschmack) + '</p>'
      + '<h4>Steckt in</h4><ul class="steckbrief__sorten">' + sorten + '</ul>';
  }

  /* Das Panel neben den Knopf legen. Es haengt am Dokument, nicht am Knopf -
     im Hero steckt der Knopf in einer Szene, die jeden Frame verschoben wird. */
  function platziere(panel, knopf) {
    var r = knopf.getBoundingClientRect();
    var breite = panel.offsetWidth;
    var hoehe = panel.offsetHeight;
    var rand = 12;
    var sy = window.scrollY || window.pageYOffset;
    var sx = window.scrollX || window.pageXOffset;

    /* Rechts daneben, wenn dort Platz ist, sonst links. */
    var rechts = r.right + rand;
    var links = r.left - rand - breite;
    var x = (rechts + breite <= window.innerWidth - rand) ? rechts
          : (links >= rand) ? links
          : Math.max(rand, Math.min(window.innerWidth - breite - rand, r.left));

    /* Oben an der Zutat ausrichten, aber nie aus dem Bild laufen. */
    var y = Math.max(rand, Math.min(window.innerHeight - hoehe - rand, r.top));

    panel.style.setProperty('--x', (x + sx) + 'px');
    panel.style.setProperty('--y', (y + sy) + 'px');
    panel.style.setProperty('--ursprung',
      (x < r.left ? 'top right' : 'top left'));
  }

  function schliesse(fokusZurueck) {
    if (!offen) return;
    var o = offen;
    offen = null;
    o.knopf.setAttribute('aria-expanded', 'false');
    o.panel.removeAttribute('data-offen');
    if (o.schatten) o.schatten.removeAttribute('data-offen');
    window.setTimeout(function () {
      if (o.panel.parentNode) o.panel.parentNode.removeChild(o.panel);
      if (o.schatten && o.schatten.parentNode) {
        o.schatten.parentNode.removeChild(o.schatten);
      }
    }, 220);
    if (fokusZurueck !== false) o.knopf.focus();
  }

  function oeffne(knopf) {
    holen().then(function (alle) {
      if (!alle) return;
      var key = knopf.getAttribute('data-zutat');
      var z = alle[key];
      if (!z) return;
      if (offen) schliesse(false);

      var alsBlatt = schmal.matches;
      var panel = document.createElement('div');
      panel.className = 'steckbrief' + (alsBlatt ? ' steckbrief--blatt' : '');
      /* Lenis glaettet das Mausrad auf der ganzen Seite und faengt das
         Ereignis am Dokument ab - auch ueber einem Kasten, der selbst
         scrollen koennte. Ohne diese Marke scrollte deshalb die SEITE, wenn
         man im Panel das Rad drehte, und das Panel ging dabei zu.
         `data-lenis-prevent` laesst Lenis dieses Element in Ruhe. */
      panel.setAttribute('data-lenis-prevent', '');
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', alsBlatt ? 'true' : 'false');
      panel.setAttribute('aria-labelledby', 'steckbrief-titel');

      /* Das Bild aus dem Knopf uebernehmen statt neu zu laden: es ist schon da. */
      var bild = knopf.querySelector('picture');
      panel.innerHTML = bau(z, bild ? bild.outerHTML : '');

      var schatten = null;
      if (alsBlatt) {
        schatten = document.createElement('div');
        schatten.className = 'steckbrief__schatten';
        document.body.appendChild(schatten);
        schatten.addEventListener('click', function () { schliesse(); });
      }
      document.body.appendChild(panel);
      if (!alsBlatt) platziere(panel, knopf);

      knopf.setAttribute('aria-expanded', 'true');
      offen = { knopf: knopf, panel: panel, schatten: schatten };

      panel.querySelector('.steckbrief__zu')
        .addEventListener('click', function () { schliesse(); });

      requestAnimationFrame(function () {
        panel.setAttribute('data-offen', '');
        if (schatten) schatten.setAttribute('data-offen', '');
        var zu = panel.querySelector('.steckbrief__zu');
        if (zu) zu.focus();
      });
    });
  }

  Array.prototype.forEach.call(knoepfe, function (k) {
    k.setAttribute('aria-expanded', 'false');
    k.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (offen && offen.knopf === k) { schliesse(); return; }
      oeffne(k);
    });
  });

  /* Escape schliesst, ein Klick daneben auch. */
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && offen) { schliesse(); ev.preventDefault(); }
  });
  document.addEventListener('pointerdown', function (ev) {
    if (!offen) return;
    if (offen.panel.contains(ev.target) || offen.knopf.contains(ev.target)) return;
    schliesse(false);
  });
  /* --- Scrollen schliesst -------------------------------------------------
     Hier stand vorher das Gegenteil: beim Scrollen wurde das Panel dem Knopf
     NACHGEFUEHRT. Im Hero klebt die Buehne aber oben (css/hero.css), also
     blieb der Knopf stehen - und das Panel klebte mit und schwebte ueber der
     naechsten Section. Genau der Fehler aus dem Screenshot.

     Jetzt gilt: sobald die SEITE scrollt, ist das Panel weg.

     Das schliesst das Scrollen IM Panel nicht aus, im Gegenteil. Solange der
     Zeiger darin ist und es etwas zu scrollen gibt, scrollt das Panel und die
     Seite steht still - dafuer sorgt `overscroll-behavior: contain` in
     css/zutaten.css. Es kommt dann gar kein Scroll-Ereignis am Fenster an,
     und das Panel bleibt offen. Erst wenn die Seite selbst scrollt, greift
     die Regel hier. */
  window.addEventListener('scroll', function () {
    if (offen) schliesse(false);
  }, { passive: true });

  /* Bei Groessenaenderung stimmt die Lage nicht mehr - auch dann zu. */
  window.addEventListener('resize', function () {
    if (offen) schliesse(false);
  });

  /* --- Zeiger verlaesst das Panel: zu -------------------------------------
     Nur mit echtem Zeiger. Auf Touch gibt es kein "Verlassen"; dort
     schliessen der Knopf, ein Tipp daneben und Escape.

     Der Knopf selbst zaehlt nicht als draussen: sonst flackerte das Panel,
     wenn man vom Panel zurueck auf die Zutat faehrt. */
  var echterZeiger = window.matchMedia('(hover: hover) and (pointer: fine)');
  document.addEventListener('pointerout', function (ev) {
    if (!offen || !echterZeiger.matches) return;
    if (ev.pointerType && ev.pointerType !== 'mouse') return;
    if (!offen.panel.contains(ev.target)) return;
    var ziel = ev.relatedTarget;
    if (ziel && (offen.panel.contains(ziel) || offen.knopf.contains(ziel))) return;
    schliesse(false);
  });
})();
